export default __webpack_public_path__ + "static/media/AcceleronsGallery_23.d46b9b05.JPG";